<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Operation" v-if="getOperation && getOperation.id">
    <!-- <b-link
      :to="{ name: 'WorksOperationsList', params: { id: getWork.id } }"
      class="text-muted"
    >
      <b-icon icon="arrow-left" class="fsize-3 mr-2"></b-icon>
      {{ $t("back_to_list_operations") }}
    </b-link> -->
    <!-- <div
      v-if="operationNotificationLoader"
      class="d-flex align-items-center justify-content-center view-area"
    >
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div> -->
    <div v-if="!operationNotificationLoader">
      <!-- <collapse-grouped-notifications
              :notification="notifications"
              id="colpase-notif"
              visible
      ></collapse-grouped-notifications> -->
    </div>

    <div
      v-if="loading"
      class="d-flex align-items-center justify-content-center view-area"
    >
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>

    <div v-if="!loading" class="row">
      <div class="col-lg-6">
        <div class="giga-card">
          <h3 class="giga-card_title">{{ $t("plug_cee") }}</h3>
          <div class="giga-card_content">
            <ul class="giga-card_list">
              <li class="giga-card_list_item block-info">
                <label>{{ $t("area_operation") }}</label>
                <span>{{ getApplicationSector.name }}</span>
              </li>
              <li class="giga-card_list_item block-info">
                <label>{{ $t("type_work") }}</label>
                <span>{{ getApplicationSectorType.name }}</span>
              </li>
              <li class="giga-card_list_item block-info">
                <label>{{ $t("plug_cee") }}</label>
                <span>{{ getOperation.fiche.number }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="giga-card">
          <h3 class="giga-card_title">{{ $t("operation_schedule") }}</h3>
          <div class="giga-card_content">
            <ul class="giga-card_list">
              <li class="giga-card_list_item block-info">
                <label>{{ $t("commitment_date") }}</label>
                <span>{{
                  moment(getOperation.beginDate, "x").format("DD/MM/YYYY")
                }}</span>
              </li>
              <li class="giga-card_list_item block-info">
                <label>{{ $t("completion_date") }}</label>
                <span>{{
                  moment(getOperation.endDate, "x").format("DD/MM/YYYY")
                }}</span>
              </li>
              <li class="giga-card_list_item block-info">
                <label>{{ $t("plug_cee") }}</label>
                <span>{{ getOperation.fiche.number }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="giga-card">
          <h3 class="giga-card_title">
            {{ $t("general_informations_operation") }}
          </h3>
          <div class="giga-card_content">
            <div class="row">
              <div class="col-lg-8">
                <ul class="giga-card_list giga-card_gap">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("denomination") }}</label>
                    <span>{{
                      getOperation.fiche && getOperation.fiche.denomination
                    }}</span>
                  </li>
                  <li class="giga-card_list_item flex-info">
                    <div class="item-info">
                      <label>{{ $t("Street_Or_Lot_Number") }}</label>
                      <span>{{
                        getOperation.institution &&
                          getOperation.institution.address &&
                          getOperation.institution.address.addressNumber
                      }}</span>
                    </div>
                    <div class="item-info">
                      <label>{{ $t("way") }}</label>
                      <span>{{
                        getOperation.institution &&
                          getOperation.institution.address &&
                          getOperation.institution.address.addressRoad
                      }}</span>
                    </div>
                    <div class="item-info">
                      <label>{{ $t("additional_address") }}</label>
                      <span>{{
                        getOperation.institution &&
                          getOperation.institution.address &&
                          getOperation.institution.address.additionalAddress
                      }}</span>
                    </div>
                  </li>
                  <li class="giga-card_list_item flex-info">
                    <div class="item-info">
                      <label>{{ $t("city") }}</label>
                      <span>{{
                        getOperation.institution &&
                          getOperation.institution.address &&
                          getOperation.institution.address.city
                      }}</span>
                    </div>
                    <div class="item-info">
                      <label>{{ $t("postal_code") }}</label>
                      <span>{{
                        getOperation.institution &&
                          getOperation.institution.address &&
                          getOperation.institution.address.postalCode
                      }}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list giga-inner_card_bg h-auto">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("precarious_volume") }}</label>
                    <span
                      >{{ getOperation.precarityVolume | formatNumber }} kWh
                      cumac</span
                    >
                  </li>
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("classic_volume") }}</label>
                    <span
                      >{{ getOperation.classicVolume | formatNumber }} kWh
                      cumac</span
                    >
                  </li>
                  <!--                  <li class="giga-card_list_item block-info">-->
                  <!--                    <label>{{ $t("economic_valorisation") }}</label>-->
                  <!--                    <span-->
                  <!--                      >€ {{ getWork.economicValorisation | formatNumber }}</span-->
                  <!--                    >-->
                  <!--                  </li>-->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-lg-12"
        v-if="
          userInfo.clientType === 'B2B2B' &&
            getOperation.beneficiary &&
            getOperation.beneficiary.isMoral
        "
      >
        <div class="giga-card">
          <h3 class="giga-card_title">
            {{ $t("beneficiary_Informations") }}
          </h3>
          <div class="giga-card_content">
            <div class="row aligne-rows">
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("email") }}</label>
                    <span>{{
                      getOperation.beneficiary.personneMoralEmail
                    }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("phone") }}</label>
                    <span>{{
                      getOperation.beneficiary.personneMoralTelephone
                    }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("beneficiary") }}</label>
                    <span>{{
                      getOperation.beneficiary.isMoral ? $t("legal_person") : ""
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="row aligne-rows">
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("siren_number_beneficiary") }}</label>
                    <span>{{ getOperation.beneficiary.siren }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("siret_number_beneficiary") }}</label>
                    <span>{{ getOperation.beneficiary.siret }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("company_name_beneficiary") }}</label>
                    <span>{{ getOperation.beneficiary.raisonSociale }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="row aligne-rows">
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("address") }}</label>
                    <span>{{ getOperation.beneficiary.addressName }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li
                    class="giga-card_list_item block-info"
                    v-if="getOperation.beneficiary.basePostalCodes"
                  >
                    <label>{{ $t("postal_code") }}</label>
                    <span>{{
                      getOperation.beneficiary.basePostalCodes.codePostal
                    }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-4">
                <ul class="giga-card_list">
                  <li
                    class="giga-card_list_item block-info"
                    v-if="getOperation.beneficiary.basePostalCodes"
                  >
                    <label>{{ $t("city") }}</label>
                    <span>{{
                      getOperation.beneficiary.basePostalCodes.nomCommune
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="giga-card">
          <h3 class="giga-card_title">
            {{ $t("installer_Informations") }}
          </h3>
          <div class="giga-card_content">
            <div class="row">
              <div class="col-lg-6">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("siret_number_beneficiary") }}</label>
                    <span>{{ getOperation.siretBeneficiare }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item block-info">
                    <label>{{ $t("company_name_beneficiary") }}</label>
                    <span>{{ getOperation.raisonSocialBeneficiare }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="giga-card">
          <h3 class="giga-card_title">
            {{ $t("technical_informations") }}
          </h3>
          <div class="giga-card_content">
            <ul class="giga-card_list cols-view">
              <li
                v-for="emmy in getOperation.emmies"
                :key="emmy.id"
                class="giga-card_list_item block-info"
              >
                <label>{{ emmy.name }}</label>
                <template
                  v-if="emmy.type === 'LIST' || emmy.type === 'CLIMATIC_ZONE'"
                >
                  <span>{{ getConditionLabel(emmy) }}</span>
                </template>
                <template v-else>
                  <span>{{ emmy.value }}</span>
                </template>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CollapseCard from "../../components/static/CollapseCard.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { notificationService } from "../service/notification.service";
import { map } from "lodash";
// import CollapseGroupedNotifications from '../../components/static/CollapseGroupedNotifications';
export default {
  // components: { CollapseCard },
  name: "Operation",
  data() {
    return {};
  },
  mounted() {
    this.getWorkByIdAction({ id: parseInt(this.$route.params["id"], 10) });
    this.getOperationByIdAction({
      idWork: parseInt(this.$route.params["id"], 10),
      idOperation: parseInt(this.$route.params["idOperation"], 10)
    });
    this.getOperationNotificationsAction({
      operationId: this.$route.params["idOperation"]
    });
  },
  computed: {
    ...mapGetters("account", { userInfo: "getCurrentUser" }),
    ...mapGetters("loader", { loading: "getLoading" }),
    ...mapGetters("loader", {
      operationNotificationLoader: "getOperationNotificationLoader"
    }),
    ...mapGetters("work", [
      "getWork",
      "getOperation",
      "getApplicationSector",
      "getApplicationSectorType"
    ]),
    ...mapGetters("notification", {
      notifications: "getOperationsNotifications"
    })
  },
  methods: {
    ...mapActions("work", ["getWorkByIdAction", "getOperationByIdAction"]),
    ...mapActions("notification", ["getOperationNotificationsAction"]),
    ...mapMutations("work", [
      "setOperation",
      "setApplicationSector",
      "setApplicationSectorType"
    ]),
    markNotificationsAsRead(notificationsIds) {
      notificationService.markNotificationsAsRead(notificationsIds, false);
    },
    getConditionLabel(emmy) {
      const condition = emmy.listConditions.find(
        c => String(c.value) === emmy.value
      );
      return condition ? condition.libelle : "";
    }
  },
  beforeDestroy() {
    this.setOperation({});
    this.setApplicationSector({});
    this.setApplicationSectorType({});
    this.markNotificationsAsRead(map(this.notifications, "id"));
  }
};
</script>
<style scoped>
/*b-form-select class*/
.custom-select {
  height: calc(1.5em + 0.75rem + 15px);
}
.aligne-rows {
  padding: 10px 0px !important;
}
</style>
